export default __webpack_public_path__ + "static/case_1-5d6728230fc0f9134e2fb8d5a2fe99dc.png";